export default [
  {
    label: 'Site Name',
    value: 'Bloomington_N'
  },
  {
    label: 'Site Alias',
    value: 'Griffy Woods'
  },
  {
    label: 'County',
    value: 'Monroe'
  },
  {
    label: 'Station Number',
    value: 66
  },
  {
    label: 'P',
    value: true
  },
  {
    label: 'E',
    value: true
  },
  {
    label: 'ΔS<sup>S</sup>',
    value: true
  },
  {
    label: 'ΔS<sup>G</sup>',
    value: false
  }
]
